import { all } from 'redux-saga/effects'

import { fundsRootSaga } from '../state/funds-slice'

export function* rootSaga() {
  yield all([fundsRootSaga()])
}
